// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BQ","text":"BR","date":"BS"};